"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/TickInCircle.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TickInCircle = function TickInCircle(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 138.4 138.4"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "tick-in-circle",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M69.2 0C31 0 0 31 0 69.2s31 69.2 69.2 69.2 69.2-31 69.2-69.2S107.4 0 69.2 0zm0 132.1c-34.7 0-62.9-28.2-62.9-62.9S34.5 6.3 69.2 6.3s62.9 28.2 62.9 62.9-28.2 62.9-62.9 62.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M69.2 12.3c-31.4 0-56.9 25.5-56.9 56.9s25.5 56.9 56.9 56.9 56.9-25.5 56.9-56.9-25.5-56.9-56.9-56.9zm0 112c-30.4 0-55-24.7-55-55 0-30.4 24.7-55 55-55 30.4 0 55 24.7 55 55 .1 30.3-24.6 55-55 55z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M94.6 45.7l-3.2-2.6c-1.5-1.2-3.8-1-5 .5L59.5 82.4l-7.8-9.6c-1.2-1.5-3.5-1.8-5-.5l-3.2 2.6c-1.5 1.2-1.8 3.5-.5 5l13.5 16.6c1.1 1.4 4.1 1.5 5.8.7.1 0 1.2-.4 4.5-5.7L95 50.7c1.3-1.6 1.1-3.8-.4-5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  })));
};
exports.default = TickInCircle;